import { Button, Flex, Popconfirm, Space, theme } from 'antd';
import { FC } from 'react';
import { BoxArrowUpRight, ExclamationCircle, PencilSquare, Trash } from 'react-bootstrap-icons';

import { AppRoutes } from '@/common/interfaces';

import { SearchConsoleAccount } from '@/modules/DomainsApi';

interface Props {
  searchConsoleAccount: Pick<SearchConsoleAccount, 'id' | 'email'> | null;
  isButtonsDisabled: boolean;
  isAccountDeleting: boolean;
  handleEdit: () => void;
  handleDelete: () => void;
}

export const SearchConsoleAccountSiteView: FC<Props> = ({
  searchConsoleAccount,
  isButtonsDisabled,
  isAccountDeleting,
  handleDelete,
  handleEdit
}) => {
  const { colorError } = theme.useToken().token;

  return (
    <Flex style={{ width: '100%' }} align="center" justify="space-between" gap={ 8 }>
      <Button
        type="link"
        target="_blank"
        style={{ paddingInline: 0 }}
        disabled={ isButtonsDisabled || !searchConsoleAccount?.id }
        href={
          AppRoutes.DomainsApiSearchConsoleAccountsById
            .replace(':searchConsoleAccountId', searchConsoleAccount?.id ?? '')
        }
      >
        { searchConsoleAccount?.email }&nbsp;
        <BoxArrowUpRight/>
      </Button>

      <Space>
        <Button size="small" icon={ <PencilSquare/> } disabled={ isButtonsDisabled } onClick={ handleEdit }/>
        <Popconfirm
          disabled={ isButtonsDisabled }
          okType="danger"
          okText="Так"
          icon={ <ExclamationCircle color={ colorError }/> }
          title="Прибрати акаунт Seacrh Console?"
          onConfirm={ handleDelete }
          placement="left"
        >
          <Button danger size="small" icon={ <Trash/> } disabled={ isButtonsDisabled } loading={ isAccountDeleting }/>
        </Popconfirm>
      </Space>
    </Flex>
  );
};
